import { IonButton, IonCard, IonCardContent, IonCol, IonContent, IonIcon, IonPage, IonRadioGroup, IonRow, IonText, useIonToast } from '@ionic/react';
import { alarmOutline, bagAddOutline, chevronDown, pricetagOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';

import ActionButton from '../../components/button/ActionButton';
import Cart from '../../components/cart/Cart';
import LoadingContainer from '../../components/loading/LoadingContainer';
import NumberSelector from '../../components/number-selector/NumberSelector';
import RadioItem from '../../components/radio/RadioItem';
import Slideshow from '../../components/slideshow/Slideshow';
import HR from '../../layouts/HR';
import Toolbar2 from '../../layouts/Toolbar2';
import { isHome, isWebView, objIsEmpty } from '../../library/Funcs';
import { AddCartPostAction, ProductViewAction, AddReminderPostAction } from '../../redux/actions/Shop';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';

import './ProductPage.css';
import InputItem from '../../components/input/InputItem';

interface Props extends RouteComponentProps<{
  product_id: string
}> { }

const ProductPage: React.FC<Props> = ({ match }) => {
  const [toast, dismiss] = useIonToast();

  const [toolbarBg, setToolbarBg] = useState('transparent')
  const [titleColor, setTitleColor] = useState('transparent')

  const dispatch = useAppDispatch()
  const { loading, productView } = useAppSelector(state => state.productView)

  let { form_loading, resp } = useAppSelector(state => state.addCartPost)

  let { form_loading2, resp2 } = useAppSelector(state => state.addReminderReducer)

  const [selectedColorId, setSelectedColorId] = useState("")
  const [selectedColorStock, setSelectedColorStock] = useState(0)
  const [selectedPrice, setSelectedPrice] = useState("")
  const [selectedOldPrice, setSelectedOldPrice] = useState("")
  const [radioChecked, setRadioChecked] = useState(false)
  const [colorsQuantity, setColorsQuantity] = useState([] as any)

  useEffect(() => {
    if (objIsEmpty(productView)) {
      dispatch(ProductViewAction(match.params.product_id));
    }

    return () => {
      if (isHome()) {
        dispatch({ type: 'PRODUCT_VIEW_RESET' })
      }
    }
  }, [dispatch])

  useEffect(() => {
    if (productView != null && !loading) {
      // تنظیم اولیه رنگ ها
      // for (let i = 0; i < productView.colors?.length; i++) {
      //   let element = productView.colors[i];

      //   if (element.stock > 0) {
      const element = productView.product?.colors[0];
      setSelectedColorId(element.id.toString());
      setSelectedColorStock(element.stock);
      setSelectedPrice(element.price);
      setSelectedOldPrice(element.old_price);
      //     break;
      //   }
      // }

      // تنظیم اولیه تعداد هر رنگ
      let quantities = [];
      for (let i = 0; i < productView.product?.colors?.length; i++) {
        let element = productView.product?.colors[i];

        quantities.push({
          colorId: element.id,
          quantity: 1
        });
      }

      setColorsQuantity(quantities)

      window.cartTotal = productView.cartTotal;
    }
  }, [loading])

  // تغییر هر رنگ
  const changeColorHandler = (e: any) => {
    if (!radioChecked) return;

    setSelectedColorId(e.detail.value);

    productView.product?.colors?.forEach((element: any) => {
      if (element.id.toString() === e.detail.value) {
        setSelectedPrice(element.price);
        setSelectedOldPrice(element.old_price);
        setSelectedColorStock(element.stock);
      }
    });

    setRadioChecked(false);
  }

  // تغییر تعداد هر رنگ
  const changeColorQuantityHandler = (id: any, quantity: any) => {
    let quantities = [...colorsQuantity];

    for (let i = 0; i < quantities.length; i++) {
      let item = quantities[i];

      if (item.colorId == id) {
        item.quantity = quantity;
      }
    }

    setColorsQuantity(quantities)
  }

  // افزودن به سبد خرید
  const addCartHandler = () => {
    let productId = parseInt(match.params.product_id);
    let colorId = parseInt(selectedColorId);
    let quantity = 0;

    let quantities = [...colorsQuantity];

    for (let i = 0; i < quantities.length; i++) {
      let item = quantities[i];

      if (selectedColorId == item.colorId.toString()) {
        quantity = item.quantity
      }
    }

    dispatch(AddCartPostAction(productId, colorId, quantity));
  }

  // افزودن به یادآوری
  const addReminderHandler = () => {
    let productId = parseInt(match.params.product_id);
    let colorId = parseInt(selectedColorId);

    dispatch(AddReminderPostAction(productId, colorId));
  }

  useEffect(() => {
    const formDone = () => {
      if (resp != null && !form_loading) {
        // تغییر تعداد در سبد خرید با هر بار افزودن به سبد
        window.cartTotal = resp.total;
      }
    }

    formDone();
  }, [form_loading])


  useEffect(() => {
    if (resp2 != null && !form_loading2) {
      if (resp2.result) {
        toast({ message: resp2.message, duration: 5000, color: "primary" })
      } else {
        toast({ message: resp2.message, duration: 2000, color: "danger" })
      }
    }
  }, [form_loading2])

  const changeHeightHandler = (e: any) => {
    const scrollY = e.detail.currentY;

    const alpha = scrollY / 180;

    setToolbarBg('rgba(8, 185, 138, ' + alpha + ')')

    if (scrollY > 210) {
      setTitleColor('rgba(255, 255, 255, 1)')
    } else {
      setTitleColor('transparent')
    }
  }

  const toolbarButtons = <React.Fragment>
    {/* <IonButton shape="round" color="white">
      <IonIcon icon={shareOutline}/>
    </IonButton> */}

    <Cart />
  </React.Fragment>

  return <LoadingContainer loading={loading}>
    <IonPage className="shop">
      <Toolbar2 title={productView.product?.name} endButtons={toolbarButtons} hasBackButton hasShadow background={toolbarBg} titleColor={titleColor} />

      <IonContent className="main-content" scrollEvents onIonScroll={changeHeightHandler}>
        <IonCard className="slideshow-card">
          <IonCardContent>
            {productView.product?.images !== undefined ? <Slideshow images={productView.product?.images} /> : null}
          </IonCardContent>
        </IonCard>

        <IonCard>
          <IonCardContent>
            <IonRow>
              <IonCol>
                <IonText className="title">{productView.product?.name}</IonText>
              </IonCol>
            </IonRow>
            <HR />
            <IonRow>
              <IonCol>
                <div className="ion-text-justify">{productView.product?.summary}</div>
              </IonCol>
            </IonRow>
          </IonCardContent>
        </IonCard>

        <IonCard>
          <IonCardContent>
            <IonRow>
              <IonCol size="3">
                <IonText className="price-title"><IonIcon src={pricetagOutline} />قیمت</IonText>
              </IonCol>
              <IonCol size="9">
                <IonText className="price-value">{selectedPrice}</IonText> {isWebView() ? <IonText className="old-price-value"><s>{selectedOldPrice}</s></IonText> : null}
              </IonCol>
            </IonRow>

            <HR />

            <IonRadioGroup value={selectedColorId} onIonChange={(e) => changeColorHandler(e)}>
              {productView.product?.colors?.map((item: any) => {
                return <IonRow key={`product-color-${item.id}`}>
                  <IonCol size="9" className="ion-no-padding">
                    <RadioItem value={item.id.toString()} label={item.color} focus={() => setRadioChecked(true)} />
                  </IonCol>

                  <IonCol size="3" className="ion-no-padding quantity-selector">
                  <InputItem type="select3" ltr value={1} disabled={item.stock <= 0} change={(quantity: any) => {changeColorQuantityHandler(item.id, quantity);}}>
                      {Array.from(Array(item.stock < item.max ? item.stock : item.max), (e, i) => {
                        return <RadioItem value={(i+1).toString()} label={(i+1).toString()} />
                      })}
                  </InputItem>
                  </IonCol>
                </IonRow>
              })}
            </IonRadioGroup>
          </IonCardContent>
        </IonCard>

        <IonRow className="selector-container">
          <IonCol size="6">
            <Link to={{ pathname: `${match.params.product_id}/desc`, state: productView.product?.description }}>
              <IonButton className="selector-button"> توضیحات </IonButton>
            </Link>
          </IonCol>
          <IonCol size="6">
            <Link to={{ pathname: `${match.params.product_id}/comments`, state: productView?.comments }}>
              <IonButton className="selector-button"> نظرات </IonButton>
            </Link>
          </IonCol>
        </IonRow>
      </IonContent>

      <IonCard className="add-cart-button">
        <IonCardContent>
          {selectedColorStock > 0 ?
            <ActionButton click={addCartHandler} loading={form_loading} noMargin>
              <IonText>افزودن به سبد خرید</IonText>
              <IonIcon slot="start" icon={bagAddOutline} />
            </ActionButton>
            :
            <ActionButton click={addReminderHandler} loading={form_loading2} noMargin color="blue">
              <IonText>موجود شد به من اطلاع بده</IonText>
              <IonIcon slot="start" icon={alarmOutline} />
            </ActionButton>
          }
        </IonCardContent>
      </IonCard>
    </IonPage>
  </LoadingContainer>
}

export default ProductPage